/* FanBoi cursor glow.
   Forces size with !important so Dawn's CSS reset can't collapse it to 0.

   13 SEP 2026 — mobile fix.
   The element was appended on every page load and parked at the CENTRE of the
   viewport (innerWidth/2, innerHeight/2) until the first mousemove. Touch
   devices never fire mousemove, so on a phone this sat dead centre of the
   screen, permanently, at z-index 2147483647 — a red blob on top of the
   homepage, the product page and, worst of all, the cart, where it washed
   across the line items and the totals. 58% of FanBoi's sessions are mobile.

   Two changes:
   1. Bail out entirely unless the device has a real hovering pointer.
   2. Start at opacity 0 and only fade in on the first genuine mousemove, so a
      hybrid device (touchscreen laptop) that reports a fine pointer still
      shows nothing until a mouse is actually used.

   It also honours prefers-reduced-motion, since a glow tracking the cursor is
   exactly the kind of thing that setting is for. */
(function () {
  function start() {
    var root = document.documentElement;
    if (!root) return;
    if (!window.matchMedia) return;

    var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!finePointer || reduceMotion) return;

    var glow = document.createElement('div');
    glow.id = 'fb-cursor-glow-el';
    glow.setAttribute('aria-hidden', 'true');

    function setImp(prop, val) { glow.style.setProperty(prop, val, 'important'); }
    setImp('position', 'fixed');
    setImp('width', '240px');
    setImp('height', '240px');
    setImp('min-width', '240px');
    setImp('min-height', '240px');
    setImp('max-width', 'none');
    setImp('max-height', 'none');
    setImp('border-radius', '50%');
    setImp('pointer-events', 'none');
    setImp('z-index', '2147483647');
    setImp('margin', '0');
    setImp('padding', '0');
    setImp('display', 'block');
    setImp('box-sizing', 'border-box');
    setImp('transform', 'translate(-50%, -50%)');
    setImp('left', (window.innerWidth / 2) + 'px');
    setImp('top', (window.innerHeight / 2) + 'px');
    setImp('background', 'radial-gradient(circle, rgba(229,0,25,0.40) 0%, rgba(229,0,25,0.15) 40%, transparent 70%)');
    setImp('transition', 'opacity 0.35s ease');
    setImp('opacity', '0');

    root.appendChild(glow);

    var shown = false;
    window.addEventListener('mousemove', function (e) {
      glow.style.setProperty('left', e.clientX + 'px', 'important');
      glow.style.setProperty('top', e.clientY + 'px', 'important');
      if (!shown) {
        shown = true;
        glow.style.setProperty('opacity', '1', 'important');
      }
    }, { passive: true });

    // A touch on a hybrid device means there is no cursor to follow.
    window.addEventListener('touchstart', function () {
      shown = false;
      glow.style.setProperty('opacity', '0', 'important');
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
